"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault")["default"];

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _app = require("@package/app");

var _storybook = require("@pikassa/storybook");

var _react = _interopRequireDefault(require("react"));

var _defaultModule = _interopRequireDefault(require("./default.module.scss"));

function ConfirmCodeForm(_ref) {
  var handleSubmit = _ref.handleSubmit,
      inProcess = _ref.inProcess;

  try {
    return /*#__PURE__*/_react["default"].createElement("form", {
      className: _defaultModule["default"]['code'],
      onSubmit: handleSubmit
    }, /*#__PURE__*/_react["default"].createElement(_storybook.Text, {
      className: _defaultModule["default"]['code__label']
    }, "\u0412\u0432\u0435\u0434\u0438\u0442\u0435 \u043A\u043E\u0434 \u0438\u0437 \u043F\u0438\u0441\u044C\u043C\u0430"), /*#__PURE__*/_react["default"].createElement(_storybook.InputField, {
      className: _defaultModule["default"]['code__input'],
      name: "code",
      disabled: inProcess
    }));
  } catch (e) {
    return /*#__PURE__*/_react["default"].createElement(_app.Error, {
      error: e
    });
  }
}

var _default = ConfirmCodeForm;
exports["default"] = _default;